import { convertHankakuToZenkaku } from '@utils_common/convertZenkakuToHankaku';

// console/admin/company/{companyId}とconsole/admin/company/{companyId}/profileで若干スタイリングが違う。
// そのためplainTextをキーにして、返却するDOM要素を変えている。

type Props = {
  index: number; // 何番目の会社紹介タイトル・文か
  title: string | undefined; // 会社紹介タイトル
  body: string | undefined; // 会社紹介タイトルの紹介文
  inputItem: string; // 会社紹介タイトル・文のコンテナのスタイル
  inputItemLabel: string; // 「会社紹介タイトル・文」それ自体のスタイル
  plainText?: string; // 会社紹介タイトル・文のスタイル
};

/**
 * 会社紹介タイトルおよび会社紹介文用のコンポーネント
 * @param props
 * @returns
 */
export const CompanyProfile = (props: Props) => {
  const { index, title, body, inputItem, inputItemLabel, plainText } = props;
  // 全角のindexに変換する
  const multiByteIndex = convertHankakuToZenkaku(index.toString());
  return (
    <>
      <div className={inputItem}>
        <label className={inputItemLabel}>会社紹介タイトル{multiByteIndex}</label>
        {plainText ? <div className={plainText}>{title}</div> : title}
      </div>
      <div className={inputItem}>
        <label className={inputItemLabel}>会社紹介文{multiByteIndex}</label>
        {plainText ? <div className={plainText}>{body}</div> : body}
      </div>
    </>
  );
};
